import isURL from 'validator/lib/isURL';

export default {
    validate: url => isURL(url),
    message: '{_field_} deve ser válido.',
}